import { FormBuilder, FormControl } from "@angular/forms";
import { VALIDATORS } from "@databank-ui";
import { FormGroupRawValue, FormGroupValue } from "@shared/interfaces/form.interface";

export type LoginFormValue = FormGroupValue<LoginFormConfig>;
export type LoginFormRawValue = FormGroupRawValue<LoginFormConfig>;

const defaultFormValue: LoginFormValue = {
    username: "",
    password: "",
    remember: null,
};

export class LoginFormConfig {
    username: FormControl<string>;
    password: FormControl<string>;
    remember: FormControl<boolean>;

    constructor(value: LoginFormValue = defaultFormValue) {
        const fb = new FormBuilder().nonNullable;

        this.username = fb.control(value.username, [VALIDATORS.requiredAndNonWhitespace]);
        this.password = fb.control(value.password, [VALIDATORS.required]);
        this.remember = fb.control(value.remember);
    }
}
